module.exports = __webpack_public_path__ + "static/media/3_r_shariki_84.95_18.98.5d2cda6f.png";